import { render, staticRenderFns } from "./VehicleBuyModal.vue?vue&type=template&id=54592826"
import script from "./VehicleBuyModal.vue?vue&type=script&lang=js"
export * from "./VehicleBuyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports